import { ModalService } from '@/components/moda-lInvoker';
import GlobalMailEditorModal from './GlobalMailEditorModal';

export interface GlobalMailEditorOptions {
  /** 容器名称，默认为 'default' */
  containerName?: string;
}

/**
 * 全局邮件编辑器服务
 * 使用全局 Modal 系统打开邮件编辑器，解决弹窗中右键菜单定位问题
 */
export const GlobalMailEditorService = {
  /**
   * 打开全局邮件编辑器
   * @param options 配置选项
   * @returns Promise，编辑器关闭时 resolve
   */
  open(options: GlobalMailEditorOptions = {}): Promise<void> {
    return ModalService.open(
      GlobalMailEditorModal,
      {},
      {
        containerName: options.containerName,
      }
    );
  },
};

export default GlobalMailEditorService;
